import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { setLang, setTranslations } from '../store/actions';

class LanguageSetter extends Component {

	async componentDidMount() {
		await this.loadTranslations(this.props.lang);
		this.props.setLangLoaded();
	}

	async componentWillReceiveProps(nextProps) {
		const { formValues, lang } = nextProps;

		if (formValues && formValues.lang !== lang) {
			await this.loadTranslations(formValues.lang);
			this.props.dispatch(setLang(formValues.lang));
		}
	}

	loadTranslations = async (locale) => {
		const translations = await import(
			/* webpackMode: "lazy", webpackChunkName: "locale-[index]" */
			`../locale/${locale}.js`);

		if (locale === 'cs') {
			await import(
				/* webpackMode: "lazy", webpackChunkName: "moment-locale-cs" */
				`moment/locale/cs`);
		}

		this.props.dispatch(setTranslations({ lang: locale, translations: translations.default }));
	};

	render() {
		return null;
	}
}


export default compose(
	connect(state => ({
		lang: state.app.lang,
		formValues: getFormValues('bookingForm')(state),
	})),
)(LanguageSetter);



// WEBPACK FOOTER //
// ./src/components/LanguageSetter.jsx